import { Controller } from "@hotwired/stimulus"
import PullToRefresh from 'pulltorefreshjs';
import { I18n } from 'i18n-js';
import locales from '../locales.json';

// Connects to data-controller="pulltorefresh"
export default class extends Controller {

  shouldRefresh = true;

  connect() {
    // Check if we're in SecurityServices context by looking at the controller namespace meta tag
    if (this.isSecurityServicesContext()) {
      return; // Don't initialize pull-to-refresh for SecurityServices controllers
    }

    const i18n = new I18n(locales);
    i18n.locale = document.querySelector("meta[name='locale']").content

    // Track where the gesture started. pulltorefreshjs does not pass the touch
    // target to shouldPullToRefresh, so we capture it ourselves and use it to
    // decide whether the actually-scrolled container is at the top.
    this._lastTouchTarget = null;
    this._onTouchStart = (e) => {
      this._lastTouchTarget = e.target;
    };
    document.addEventListener('touchstart', this._onTouchStart, { passive: true });

    PullToRefresh.init({
      instructionsPullToRefresh: i18n.t('pulltorefresh.instructionsPullToRefresh'),
      instructionsReleaseToRefresh: i18n.t('pulltorefresh.instructionsReleaseToRefresh'),
      instructionsRefreshing: i18n.t('pulltorefresh.instructionsRefreshing'),
      shouldPullToRefresh: () => {
        // Disable when AI chat or other pages set this flag (e.g. nested scroll areas)
        if (window.disablePullToRefresh === true) return false;
        return this.isAtTopForTouch(this._lastTouchTarget);
      },
      onRefresh: () => {
        return new Promise((resolve) => {
          window.location.reload()
          resolve()
        })
      }
    })
  }

  disconnect() {
    if (this._onTouchStart) {
      document.removeEventListener('touchstart', this._onTouchStart);
      this._onTouchStart = null;
    }
  }

  // True when every scrollable container above the touch target is scrolled to
  // the top. This lets nested scroll areas (e.g. the email reading pane) own the
  // upward gesture while still allowing pull-to-refresh on regular pages.
  isAtTopForTouch(target) {
    let el = target;
    while (el && el !== document.body && el !== document.documentElement) {
      if (el.nodeType === 1 && this.isScrollable(el) && el.scrollTop > 0) {
        return false;
      }
      el = el.parentElement;
    }
    // Fallback to the main content scroller for pages without nested scrollers.
    const root = document.getElementById('content-frame') || document.scrollingElement || document.documentElement;
    return !root || root.scrollTop <= 0;
  }

  isScrollable(el) {
    if (el.scrollHeight <= el.clientHeight) return false;
    const overflowY = getComputedStyle(el).overflowY;
    return overflowY === 'auto' || overflowY === 'scroll';
  }

  isSecurityServicesContext() {
    // Check if the controller has disabled pull-to-refresh
    return window.disablePullToRefresh === true;
  }
}
